import React from "react";

import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import { NavDropdown } from "react-bootstrap";

import Logo from "../../common/images/logo.png";
import UserAvatar from "../../common/components/UserAvatar";
import { PALETTE } from "../../common/ThemeConstants";
import { useAuth } from "../../auth/hook";
import { NavbarResponsive } from "../../common/components/NavbarResponsive";
import SignedCard from "./SignedCard";

export default function AccountHeader() {
  const auth = useAuth();
  const user = auth.user;
  const role = auth.role;

  const cover = user.cover ? user.cover : undefined;

  return (
    <NavbarResponsive>
      <Container style={{ width: "100%" }}>
        <Navbar.Brand style={{ padding: 0 }}>
          <img
            className="d-block"
            width={71}
            src={Logo}
            alt="Federico Bartoli PT"
          ></img>
        </Navbar.Brand>
        <div
          className="align-self-center d-flex"
          style={{ marginLeft: "1rem" }}
        >
          <NavDropdown
            align={{ lg: "start" }}
            className="align-self-center"
            drop="start"
            title={
              <div className="m-0 align-self-center">
                <UserAvatar
                  firstname={user.firstname}
                  lastname={user.lastname}
                  size={37}
                  fontSize={14}
                  shadow={false}
                  background={PALETTE.KINDALIGHTGRAY}
                  color={PALETTE.DARKGRAY}
                  hoverable={true}
                  cover={cover}
                  borderColor={PALETTE.WHITE}
                />
              </div>
            }
            id="nav-dropdown"
          >
            <SignedCard user={user} role={role} onSignOut={auth.logOut} />
          </NavDropdown>
        </div>
      </Container>
    </NavbarResponsive >
  );
}
